import { useSelector } from 'react-redux'

const useIsReportOnlyRole = () => {
  const permissions = useSelector(state => state.account.permissions)
  if (!permissions) return false
  return permissions.includes('emailCampaign_view') && !permissions.includes('emailCampaign_create')
}

export default useIsReportOnlyRole
